import React, { useEffect, useState } from "react";
import BillPaymentService from "./BillPaymentService";
import { SERVICE_ICONS } from "../../Constant.js";
import { NavLink } from "react-router-dom";

const BillpayService = () => {
  const { paymentServiceOption, getOpTypeData } = BillPaymentService();
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    paymentServiceOption();
  }, []);

  const displayedItems = showAll ? getOpTypeData : getOpTypeData?.slice(0, 7);

  // Mapping serviceTypeID to slug
  const serviceTypeSlugMap = {
    1: "recharge",
    11: "billpayment",
    // Add more if needed
  };

  return (
    <section className="seo-grid-section" style={{ background: "#EBF2FB" }}>
      <div className="content-wrapper cus-rewards-01">
        <h2>Recharges &amp; Bill Payments</h2>
        <p>
          Enjoy lightning fast payments, exciting rewards and seamless
          transactions on every recharge &amp; bill payment
        </p>

        <ul>
          {displayedItems?.map((item, index) => {
            const iconKey = item?.name.replace(/\s+/g, "");
            const icon = SERVICE_ICONS[iconKey] || SERVICE_ICONS["GiftCards"];

            const serviceSlug =
              serviceTypeSlugMap[item.serviceTypeID] || "otherservice";
            const nameSlug = item.name.replace(/\s+/g, "").toLowerCase();

            return (
              <li key={index}>
                <NavLink
                  to={`/${serviceSlug}/${nameSlug}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <img src={icon} alt={item?.name} loading="lazy" />
                  <label>{item?.name}</label>
                </NavLink>
              </li>
            );
          })}
        </ul>

        {getOpTypeData?.length > 7 && (
          <button
            className="sc-f9b498a8-1 cJHPFK"
            type="button"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "View Less" : "View All"}
          </button>
        )}
      </div>
    </section>
  );
};

export default BillpayService;
